import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 20 20'>
  <path d='M10.8332 16.6667V6.52504L15.4915 11.1834L16.6665 10L9.99984 3.33337L3.33317 10L4.50817 11.175L9.1665 6.52504V16.6667H10.8332Z' fill={color} />
</svg>
